"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.string.starts-with");

var _regionData = _interopRequireDefault(require("./regionData"));

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

var mapLoaded = false;
var mapLoading = false;
var _default = {
  name: 'AddressCascader',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      options: [],
      selected: [],
      regionText: '',
      detailText: '',
      visible: false,
      map: null,
      marker: null,
      searchTimer: null,
      currentCoordinate: null,
      autocompleteResults: [],
      autocompleteVisible: false,
      autocompleteIndex: -1,
      autoCompleteTimer: null
    };
  },
  computed: {
    displayText: function displayText() {
      if (this.regionText && this.detailText) {
        return this.regionText + ' ' + this.detailText;
      }

      return this.regionText || this.detailText || '';
    },
    amapApi: function amapApi() {
      return this.$store ? this.$store.state.api.amapApi : '';
    },
    amapSecurityJsCode: function amapSecurityJsCode() {
      return this.$store ? this.$store.state.api.amapSecurityJsCode : '';
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        if (!val) {
          this.regionText = '';
          this.detailText = '';
          this.selected = [];
          return;
        }

        var matched = this.matchRegion(val);

        if (matched) {
          this.regionText = matched.region;
          this.detailText = matched.detail;
        } else {
          var spaceIdx = val.indexOf(' ');

          if (spaceIdx > -1) {
            this.regionText = val.substring(0, spaceIdx);
            this.detailText = val.substring(spaceIdx + 1);
          } else {
            this.regionText = '';
            this.detailText = val;
          }
        }
      }
    },
    regionText: function regionText() {
      this.searchOnMap();
    },
    detailText: function detailText() {
      this.searchOnMap();
    }
  },
  methods: {
    // 尝试用省市区数据匹配文本中的地区前缀，返回 { region, detail }
    // 例如："北京市 朝阳区 望京SOHO" -> { region: '北京市 朝阳区', detail: '望京SOHO' }
    matchRegion: function matchRegion(text) {
      var trimmed = (text || '').trim();
      if (!trimmed) return null;

      var _iterator = _createForOfIteratorHelper(_regionData.default),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var province = _step.value;

          if (trimmed.startsWith(province.label)) {
            var rest = trimmed.substring(province.label.length).trim();
            var regionParts = [province.label];
            var cities = province.children || [];

            var _iterator2 = _createForOfIteratorHelper(cities),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var city = _step2.value;

                // 直辖市（省级与市级同名），跳过市级直接匹配区
                if (city.label === province.label) {
                  var _iterator3 = _createForOfIteratorHelper(city.children || []),
                      _step3;

                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                      var area = _step3.value;

                      if (rest.startsWith(area.label)) {
                        rest = rest.substring(area.label.length).trim();
                        regionParts.push(area.label);
                        return {
                          region: regionParts.join(' '),
                          detail: rest
                        };
                      }
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }

                  return {
                    region: regionParts.join(' '),
                    detail: rest
                  };
                }

                if (rest.startsWith(city.label)) {
                  rest = rest.substring(city.label.length).trim();
                  regionParts.push(city.label);

                  var _iterator4 = _createForOfIteratorHelper(city.children || []),
                      _step4;

                  try {
                    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                      var _area = _step4.value;

                      if (rest.startsWith(_area.label)) {
                        rest = rest.substring(_area.label.length).trim();
                        regionParts.push(_area.label);
                        return {
                          region: regionParts.join(' '),
                          detail: rest
                        };
                      }
                    }
                  } catch (err) {
                    _iterator4.e(err);
                  } finally {
                    _iterator4.f();
                  }

                  return {
                    region: regionParts.join(' '),
                    detail: rest
                  };
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            return {
              region: regionParts.join(' '),
              detail: rest
            };
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return null;
    },
    onDialogOpened: function onDialogOpened() {
      var _this = this;

      this.autocompleteResults = [];
      this.autocompleteVisible = false;
      this.autocompleteIndex = -1;
      this.initMap();
      this.$nextTick(function () {
        var input = _this.$refs.addressInput;

        if (input) {
          input.focus();
        }
      });
    },
    handleDetailInput: function handleDetailInput(val) {
      var _this2 = this;

      if (this.autoCompleteTimer) {
        clearTimeout(this.autoCompleteTimer);
      }

      if (!val || val.trim().length < 2) {
        this.autocompleteResults = [];
        this.autocompleteVisible = false;
        return;
      }

      this.autoCompleteTimer = setTimeout(function () {
        _this2.queryAutocomplete(val);
      }, 300);
    },
    queryAutocomplete: function queryAutocomplete(keyword) {
      var _this3 = this;

      if (!window.AMap) {
        this.loadAmapScript().then(function () {
          _this3.doAutocomplete(keyword);
        });
        return;
      }

      this.doAutocomplete(keyword);
    },
    doAutocomplete: function doAutocomplete(keyword) {
      var _this4 = this;

      window.AMap.plugin('AMap.AutoComplete', function () {
        var auto = new window.AMap.AutoComplete({
          citylimit: false
        });
        auto.search(keyword, function (status, result) {
          if (status === 'complete' && result.tips) {
            _this4.autocompleteResults = result.tips.slice(0, 8);
            _this4.autocompleteVisible = _this4.autocompleteResults.length > 0;
            _this4.autocompleteIndex = -1;
          } else {
            _this4.autocompleteResults = [];
            _this4.autocompleteVisible = false;
          }
        });
      });
    },
    selectAutocompleteItem: function selectAutocompleteItem(item) {
      this.autocompleteVisible = false;
      this.autocompleteResults = [];
      var district = (item.district || '').trim();
      var name = (item.name || '').trim();
      var detailPart = name;
      var regionPart = district;

      if (district && name.startsWith(district)) {
        detailPart = name.substring(district.length).trim();
      } else if (district && name.indexOf(district) === 0) {
        detailPart = name.substring(district.length).trim();
      }

      this.regionText = regionPart.replace(/\//g, ' ');
      this.detailText = detailPart;
      this.emitValue(); // 直接使用 AutoComplete 搜索结果中自带的坐标，比 Geocoder 更准确

      if (item.location && item.location.lng != null && item.location.lat != null) {
        var lng = item.location.lng;
        var lat = item.location.lat;
        this.currentCoordinate = {
          lng: lng,
          lat: lat
        };

        if (this.map) {
          this.map.setCenter([lng, lat]);

          if (this.marker) {
            this.marker.setPosition([lng, lat]);
          }
        }
      }

      this.handleConfirm();
    },
    handleEnterKey: function handleEnterKey() {
      if (this.autocompleteVisible && this.autocompleteIndex >= 0 && this.autocompleteResults.length > 0) {
        this.selectAutocompleteItem(this.autocompleteResults[this.autocompleteIndex]);
        return;
      }

      if (this.autocompleteResults.length > 0) {
        this.selectAutocompleteItem(this.autocompleteResults[0]);
        return;
      } // 没有匹配结果时，直接确认


      this.emitValue();
      this.handleConfirm();
    },
    handleConfirm: function handleConfirm() {
      this.emitValue();

      if (this.currentCoordinate) {
        this.$emit('coordinate-change', this.currentCoordinate);
      }

      this.visible = false;
    },
    emitValue: function emitValue() {
      var result = this.regionText;

      if (this.detailText) {
        result = result ? result + ' ' + this.detailText : this.detailText;
      }

      this.$emit('input', result);
      this.$emit('change', result); // 将省市区与详细地址分别回传，便于父组件拆分自动填入

      this.$emit('region-change', this.regionText);
      this.$emit('detail-change', this.detailText);
    },
    // 地图相关
    loadAmapScript: function loadAmapScript() {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        if (typeof window.AMap !== 'undefined') {
          resolve();
          return;
        }

        if (mapLoading) {
          var check = setInterval(function () {
            if (typeof window.AMap !== 'undefined') {
              clearInterval(check);
              resolve();
            }
          }, 200);
          return;
        }

        mapLoading = true;
        window._AMapSecurityConfig = {
          securityJsCode: _this5.amapSecurityJsCode
        };
        var callbackName = 'initAddressCascaderMap_' + Date.now();

        window[callbackName] = function () {
          mapLoaded = true;
          mapLoading = false;
          resolve();
          delete window[callbackName];
        };

        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = _this5.amapApi + '&callback=' + callbackName;
        script.async = true;
        script.defer = true;

        script.onerror = function () {
          mapLoading = false;
          reject(new Error('地图脚本加载失败'));
        };

        document.head.appendChild(script);
      });
    },
    initMap: function () {
      var _initMap = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this6 = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.loadAmapScript();

              case 3:
                this.$nextTick(function () {
                  var container = document.getElementById('addressCascaderMap');
                  if (!container || container.offsetHeight === 0) return;

                  if (_this6.map) {
                    _this6.map.destroy();

                    _this6.map = null;
                  }

                  _this6.map = new window.AMap.Map('addressCascaderMap', {
                    zoom: 15,
                    center: [108.370859, 22.678838],
                    resizeEnable: true
                  });
                  _this6.marker = new window.AMap.Marker({
                    position: [108.370859, 22.678838]
                  });

                  _this6.map.add(_this6.marker);

                  _this6.searchOnMap();
                });
                _context.next = 8;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function initMap() {
        return _initMap.apply(this, arguments);
      }

      return initMap;
    }(),
    searchOnMap: function searchOnMap() {
      var _this7 = this;

      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }

      this.searchTimer = setTimeout(function () {
        _this7.doSearch();
      }, 500);
    },
    doSearch: function doSearch() {
      var _this8 = this;

      var addr = (this.regionText + ' ' + this.detailText).trim();
      if (!addr || !this.map || !window.AMap) return;
      window.AMap.plugin('AMap.PlaceSearch', function () {
        var placeSearch = new window.AMap.PlaceSearch({
          citylimit: false,
          pageSize: 1,
          pageIndex: 1
        });
        placeSearch.search(addr, function (status, result) {
          if (status === 'complete' && result.poiList && result.poiList.pois.length > 0) {
            var poi = result.poiList.pois[0];
            var lng = poi.location.lng;
            var lat = poi.location.lat;
            _this8.currentCoordinate = {
              lng: lng,
              lat: lat
            };

            _this8.map.setCenter([lng, lat]);

            if (_this8.marker) {
              _this8.marker.setPosition([lng, lat]);
            }
          }
        });
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.map) {
      this.map.destroy();
      this.map = null;
    }
  }
};
exports.default = _default;